import { useState } from "react";

import { Box, makeStyles, Collapse, Typography } from "@material-ui/core";

import { OverviewTab } from "./tabs/overview";
import { DetailedAnalysis } from "./tabs/DetailedAnalysis";
import { HorizontalTabs } from "../../components/horizontalTabs";
import { SensitivityAnalysisTab } from "./tabs/sensitivityAnalysis";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: `${theme.spacing(2.5)}px ${theme.spacing(4)}px`,
    height: "100%",
    boxSizing: "border-box",
  },
  title: {
    marginBottom: theme.spacing(1.6),
    fontWeight: 400,
  },
}));

export const NOIPage = () => {
  const classes = useStyles();
  const [tab, setTab] = useState(0);

  const getActiveTabComponent = () => {
    switch (tab) {
      case 1:
        return (
          <Collapse in={tab === 1}>
            <SensitivityAnalysisTab />
          </Collapse>
        );
      case 2:
        return (
          <Collapse in={tab === 2}>
            <DetailedAnalysis />
          </Collapse>
        );
      default:
        return (
          <Collapse in={tab === 0}>
            <OverviewTab />
          </Collapse>
        );
    }
  };

  return (
    <Box className={classes.root}>
      <Typography className={classes.title} variant="h2">
        NOI Increase
      </Typography>

      <HorizontalTabs
        tab={tab}
        setTab={setTab}
        tabNames={["Overview", "Sensitivity Analysis", "Detailed Analysis"]}
      />
      {getActiveTabComponent()}
    </Box>
  );
};
